// TODO: refactor Contentful to not need those mappings

const CONTENTFUL_COMPONENTS_STYLE_MAP = {
  Default: 'default',
  Dark: 'dark',
  Subtle: 'subtle',
  Wash: 'wash',
  'Dark Subtle': 'darkwash',
  Primary: 'primary'
};
const LAYOUT_MAP = {
  Top: 'top',
  Left: 'left',
  Right: 'right',
  Bottom: 'bottom'
};
const MEDIA_TYPE_MAP = {
  Image: 'image',
  Lotti: 'lotti',
  Video: 'video',
  None: 'none'
};
const IMAGE_FIT_MAP = {
  Cover: 'cover',
  Contain: 'contain'
};
export { CONTENTFUL_COMPONENTS_STYLE_MAP, IMAGE_FIT_MAP, LAYOUT_MAP, MEDIA_TYPE_MAP };
//# sourceMappingURL=contentToPropsMap.js.map
